import { useQuery } from '@apollo/client';
import { ConnectedPageLayout } from 'components/layout/page-layout';
import { useIsV2JobVew } from 'hooks/company';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';

import { Query, Job } from '@libs/graphql-types';

import JobV1 from './job-v1';
import { GET_JOB_INFO } from './job-v1/queries';
import JobV2 from './job-v2';

interface JobProps extends RouteComponentProps<{ id: string }> {}

const JobPage = (props: JobProps) => {
  const jobId = props.match.params.id;
  const { data, loading, called } = useQuery<Query>(GET_JOB_INFO, {
    variables: { id: jobId },
  });
  const isV2JobVew = useIsV2JobVew({ job: data?.job as Job });

  if (loading || !called) {
    return (
      <ConnectedPageLayout
        documentTitle="Job Details"
        headerProps={{ accountProps: {} }}
        drawerProps={{}}
        isLoading={loading}
      >
        <Box>
          <LinearProgress />
        </Box>
      </ConnectedPageLayout>
    );
  }

  if (isV2JobVew) {
    return <JobV2 {...props} />;
  }

  return <JobV1 {...props} />;
};

export default JobPage;
